module.exports = __webpack_public_path__ + "static/media/ic-check2.a153485d.svg";